export {default} from './ColorPicker';
